import { AnimatedLoader } from 'smartsuite-ui';

function LoadingButton(props) {
    const { type, isLoading, children, ...remainingProps } = props;

    return (
        <button type="button" {...remainingProps}>
            <div style={{ position: 'relative' }}>
                <div style={{ visibility: isLoading ? 'hidden' : 'visible' }}>
                    {children}
                </div>
                {isLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        }}
                    >
                        <AnimatedLoader />
                    </div>
                )}
            </div>
        </button>
    );
}

export default LoadingButton;
